import _toConsumableArray from "/home/runner/work/dr-todd-chiro/dr-todd-chiro/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/runner/work/dr-todd-chiro/dr-todd-chiro/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/dr-todd-chiro/dr-todd-chiro/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var u = Object.prototype.hasOwnProperty,
    p = Object.getOwnPropertySymbols,
    x = Object.prototype.propertyIsEnumerable,
    $ = function $(e, i) {
  var t = {};

  for (var s in e) {
    u.call(e, s) && i.indexOf(s) < 0 && (t[s] = e[s]);
  }

  if (e != null && p) {
    var _iterator = _createForOfIteratorHelper(p(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var s = _step.value;
        i.indexOf(s) < 0 && x.call(e, s) && (t[s] = e[s]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return t;
};

var b = /*#__PURE__*/function () {
  function b(i) {
    var _this = this;

    _classCallCheck(this, b);

    this.config = i, this.mergeRules = function () {
      var s = new Map();

      for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
        t[_key] = arguments[_key];
      }

      return t.filter(function (n) {
        return n;
      }).forEach(function (n) {
        return n.forEach(function (o) {
          return s.set("".concat(o[2], " ").concat(o[0]), o);
        });
      }), Array.from(s.values());
    }, this.processTransformers = function (t) {
      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = [];

      var _iterator2 = _createForOfIteratorHelper(_this.config.transformers || []),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var o = _step2.value;
          var r = o(t, s, _this);
          r && n.push.apply(n, _toConsumableArray(r));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return n.length ? n : [t];
    }, this.extractRulesByBp = function (t) {
      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var n = arguments.length > 2 ? arguments[2] : undefined;
      return Object.keys(t || {}).reduce(function (o, r) {
        var _o$;

        if (typeof t[r] == "object") {
          if (Array.isArray(t[r])) {
            var a;

            _this.config.breakpoints.forEach(function (f, c) {
              var _o;

              var h = t[r];
              c < h.length && (a = h[c]), a != null && (_o = o[c + 1]).push.apply(_o, _toConsumableArray(_this.processTransformers([r, a, s], c + 1)));
            });
          } else _this.extractRulesByBp(t[r], s + r, o);
        } else (_o$ = o[0]).push.apply(_o$, _toConsumableArray(_this.processTransformers([r, t[r], s])));
        return o;
      }, n || [0].concat(_toConsumableArray(_this.config.breakpoints)).map(function (o) {
        return [];
      }));
    }, this.st = function () {
      for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        t[_key2] = arguments[_key2];
      }

      var s = t.map(function (n) {
        return Array.isArray(n) ? n : _this.extractRulesByBp(n);
      });
      return [0].concat(_toConsumableArray(_this.config.breakpoints)).map(function (n, o) {
        return _this.mergeRules.apply(_this, _toConsumableArray(s.map(function (r) {
          return r[o];
        }))).map(function (r) {
          return _this.className(r, o);
        }).join(" ");
      }).join(" ");
    }, this.canonize = function (t) {
      return function () {
        for (var _len3 = arguments.length, s = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          s[_key3] = arguments[_key3];
        }

        var n = function n(o) {
          var _o$className = o.className,
              r = _o$className === void 0 ? "" : _o$className,
              _o$css = o.css,
              a = _o$css === void 0 ? {} : _o$css,
              f = o.as,
              c = $(o, ["className", "css", "as"]);
          return n.st_classes = _this.st.apply(_this, _toConsumableArray(s.map(function (h) {
            return typeof h == "function" ? h(o, _this) : h;
          })).concat([a])) + " " + (t.st_classes || ""), c.className = "".concat(r, " ").concat(n.st_classes).trim(), _this.config.pragma(f || t, c);
        };

        return n;
      };
    }, this.toString = function () {
      var t = _this.rules[0].join("\n");

      return _this.config.breakpoints.forEach(function (s, n) {
        t += _this.mqString(n, _this.rules[n + 1].join("\n"));
      }), t;
    }, this.mqString = function (t) {
      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var n = _this.config.breakpoints[t];
      var o = "@media screen and ";
      return n[0] == "none" ? o += "(max-width: ".concat(n[1], ")") : n[1] == "none" ? o += "(min-width: ".concat(n[0], ")") : o += "(min-width: ".concat(n[0], ") and (max-width: ").concat(n[1], ")"), "".concat(o, "{\n").concat(s, "}");
    }, this.rules = [0].concat(_toConsumableArray(i.breakpoints)).map(function () {
      return [];
    }), this.cache = this.rules.map(function () {
      return new Map();
    });
  }

  _createClass(b, [{
    key: "clear",
    value: function clear() {
      var _this2 = this;

      [0].concat(_toConsumableArray(this.config.breakpoints)).forEach(function (i, t) {
        _this2.rules[t] = [], _this2.cache[t].clear();
      });
    }
  }, {
    key: "hydrate",
    value: function hydrate() {
      var _this3 = this;

      this.clear();
      var i = document.getElementById("st-css-styles");
      i == null || i.innerText.split("@media").map(function (t, s) {
        t.split("\n").forEach(function (n, o) {
          if (!s || o) {
            var r = /^\.(st[a-z0-9]+)(.*{.*?})}?$/.exec(n);
            r ? (_this3.rules[s].push(".".concat(r[1]).concat(r[2])), _this3.cache[s].set(r[1], r[2])) : console.log("no match!!", n);
          }
        });
      }), this.sheet = i.sheet, console.log(this.sheet);
    }
  }, {
    key: "onNewRule",
    value: function onNewRule(i, t) {
      if (this.rules[t].push(i), this.sheet) if (t > 0) {
        var s = this.sheet.cssRules[this.sheet.cssRules.length - this.config.breakpoints.length - 1 + t];
        s.insertRule(i, s.cssRules.length);
      } else this.sheet.insertRule(i, this.sheet.cssRules.length - this.config.breakpoints.length);
    }
  }, {
    key: "className",
    value: function className(i) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var s = "".concat(i[2], "{").concat(i[0].replace(/[A-Z]/g, "-$&").toLowerCase(), ":").concat(i[1], "}"),
          n = this.cache[t].get(s);
      if (n) return n;
      var o = "st".concat(t).concat(this.cache[t].size.toString(36));
      return this.onNewRule(".".concat(o).concat(s), t), this.cache[t].set(s, o), o;
    }
  }]);

  return b;
}();

var m = {
  w: "width",
  h: "height",
  minw: "minWidth",
  minh: "minHeight",
  maxw: "maxWidth",
  maxh: "maxHeight"
},
    v = Object.keys(m),
    w = function w(e) {
  var i = m[e[0]];
  if (i) return typeof e[1] == "number" ? [[i, e[1] <= 1 ? "".concat(e[1] * 100, "%") : "".concat(e[1], "px"), e[2]]] : [[i, e[1], e[2]]];
},
    g = ["p", "px", "py", "pt", "pr", "pb", "pl"],
    d = ["m", "mx", "my", "mt", "mr", "mb", "ml"],
    S = [].concat(g, d),
    _ = function _(e) {
  var i = /^(p|m)(x|y|l|r|t|b)?$/.exec(e[0]);

  if (i) {
    var t = i[1] === "p" ? "padding" : "margin",
        s = {
      Left: ["x", "l"],
      Right: ["x", "r"],
      Top: ["y", "t"],
      Bottom: ["y", "b"]
    },
        n = typeof e[1] == "number" ? "".concat(e[1], "px") : e[1],
        o = [];
    return Object.keys(s).forEach(function (r) {
      return (s[r].includes(i[2]) || !i[2]) && o.push([t + r, n, e[2]]);
    }), o;
  }
},
    y = {
  size: "fontSize",
  weight: "fontWeight",
  align: "textAlign",
  textTransform: "textTransform",
  color: "color"
},
    R = Object.keys(y),
    P = function P(e) {
  var i = y[e[0]];
  if (i) return [[i, i === "fontSize" && typeof e[1] == "number" ? "".concat(e[1], "px") : e[1], e[2]]];
},
    E = ["show", "hide", "visible", "invisible"],
    B = function B(e) {
  if (e[0] === "show" && !e[1] || e[0] === "hide" && e[1]) return [["display", "none", e[2]]];
  if (e[0] === "visible" && !e[1] || e[0] === "invisible" && e[1]) return [["visibility", "hidden", e[2]]];
},
    z = function z(e, i, t) {
  return function (s, n) {
    var o = s[e] || t,
        r = typeof i == "function" ? i(s) : i;
    if (!Array.isArray(o)) return r[o];
    var a;
    var f = n.config.breakpoints.map(function (c, h) {
      if (h < o.length && (a = o[h]), r[a]) {
        var l = n.extractRulesByBp(r[a]);
        return n.mergeRules(l[0], l[h + 1]);
      }
    });
    return [void 0].concat(_toConsumableArray(f));
  };
},
    A = function A() {
  for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    e[_key4] = arguments[_key4];
  }

  return function (i, t) {
    var _ref;

    var s = {};
    return (_ref = []).concat.apply(_ref, e).forEach(function (n) {
      i[n] !== void 0 && (s[n] = i[n]);
    }), s;
  };
};

export { b as StCss, d as marginShorthandProps, g as paddingShorthandProps, v as sizeShorthandProps, w as sizeShorthands, S as spacingShorthandProps, _ as spacingShorthands, A as styleProps, R as textShorthandProps, P as textShorthands, z as variant, E as visibilityShorthandProps, B as visibilityShorthands };